var render = function (_h,_vm) {var _c=_vm._c;return _c('img',{staticClass:"mt-5 blank-document",attrs:{"src":"/assets/img/blank_document.png"}})}
var staticRenderFns = []

export { render, staticRenderFns }